var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white px-3",on:{"click":_vm.signOut}},[_vm._v(_vm._s(_vm.options.signOutButton))])}
var staticRenderFns = []

export { render, staticRenderFns }